<form *ngIf="cashbackGroupForm" [formGroup]="cashbackGroupForm" (ngSubmit)="onSubmit(cashbackGroupForm)" class="content-card">
  <mat-card class="form-card" style="max-width: 1200px;">
    <mat-card-header>
      <mat-card-title>
        <h5>Cashback Group {{cashbackGroup?.code}}</h5>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>


      <div fxLayout="row" fxLayoutGap="20px">
        <div fxFlex="40">
          <ng-container *appHasRoles="['admin', 'marketing']">

            <h3>Enabled</h3>
            <div fxLayout="column">
              <mat-checkbox formControlName="isEnabled">Enabled</mat-checkbox>
            </div>

            <app-date-edit formControlName="activeFrom" placeholder="Active from"></app-date-edit>
            <app-date-edit formControlName="activeUntil" placeholder="Active until"></app-date-edit>


            <h3>Cashback Group Data</h3>
            <div fxLayout="column">
              <mat-form-field>
                <input matInput placeholder="Code" formControlName="code" maxlength="15" required>
              </mat-form-field>
              </div>

              <div fxLayout="column">
              <mat-form-field>
                <input matInput placeholder="Name" formControlName="name" maxlength="100" required>
              </mat-form-field>
            </div>

            <h3>Cashback Parameters</h3>
            <div fxLayout="column">
              <mat-form-field>
                <input matInput placeholder="Factor" formControlName="cashbackFactor" type="number" required>
              </mat-form-field>

              <small>e.g. 0.01 = 1%, 0.005 = 0.5%</small>
              <br />
            </div>
            <div fxLayout="column">
              <mat-form-field>
                <input matInput placeholder="Max. per Month" formControlName="maxCashbackPerMonth" type="number" required>
              </mat-form-field>
            </div>

            <div fxLayout="column">
              <mat-form-field>
                <input matInput placeholder="Max. per Transaction" formControlName="maxCashbackPerTransaction" type="number" required>
              </mat-form-field>
            </div>

            <div fxLayout="column">
              <mat-form-field>
                <input matInput placeholder="Merchant IDs" formControlName="filterMerchantIds" type="text">
              </mat-form-field>

              <small>Comma separated list e.g. 1234567890, 2345678901</small>
              <br />
            </div>

            <div fxLayout="column">
              <mat-form-field>
                <input matInput placeholder="MCC Codes" formControlName="filterMccCodes" type="text">
              </mat-form-field>

              <small>Comma separated list, ranges, asterisk as wildcard for digits e.g. 1234, 12**, 2000-2999</small>
              <br />

            </div>


          </ng-container>
        </div>
      </div>

    </mat-card-content>

    <mat-card-actions align="end">
      <button mat-raised-button color="accent" type="button" (click)="returnBack()">Cancel</button>
      <button mat-raised-button color="primary" type="submit" [disabled]="!cashbackGroupForm.valid">Save</button>
    </mat-card-actions>
  </mat-card>
</form>
